import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import AuthGuard from "../auth-guard";
import Matters from "@/components/Matter/Matters.vue";
import Discovery from "@/components/Matter/Discovery.vue";
import Propound from "@/components/Matter/Discovery/Propound.vue";
import CreateMatter from "@/components/Matter/CreateMatter.vue";
import Matter from "@/components/Matter/Matter.vue";
import Woolsey from "@/components/Matter/Woolsey.vue";
import BobcatFire from "@/components/Matter/BobcatFire.vue";
import DixieFire from "@/components/Matter/DixieFire.vue";
import ContentsList from "@/components/Matter/ContentsList.vue";

import Login from "@/components/User/Login.vue";
import Signup from "@/components/User/Signup.vue";
import PartyForm from "@/components/Matter/Plaintiffs/PartyForm.vue";
import Demand from "@/components/Matter/Plaintiffs/Demand.vue";
// import SelectedDocForm from "@/components/Matter/Plaintiffs/SelectedDocForm.vue";
import ClientForm from "@/components/ClientForm.vue";
// import AdminContentsStepper from "@/components/AdminContentsStepper.vue";
import ContentsStepper3 from "@/components/Matter/ContentsStepper3.vue";
import NewUserAdmin from "@/components/NewUserAdmin.vue";
import Admin from "@/components/Admin.vue";
import MassTorts from "@/components/MassTorts.vue";
import MassTortMatter from "@/components/Matter/MassTortMatter.vue";
import ThirdPartyPortal from "@/components/ThirdPartyPortal.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/new-user-admin",
    name: "NewUserAdmin",
    component: NewUserAdmin
  },
  {
    path: "/woolsey",
    name: "Woolsey",
    props: true,
    component: Woolsey
  },
  {
    path: "/contents-list",
    name: "ContentsList",
    props: true,
    component: ContentsList
  },
  {
    path: "/portal",
    name: "ThirdPartyPortal",
    props: true,
    component: ThirdPartyPortal
  },
  {
    path: "/admin",
    name: "Admin",
    props: true,
    component: Admin
  },
  {
    path: "/admin/mass-torts",
    name: "MassTorts",
    props: true,
    component: MassTorts
  },
  {
    path: "/admin/mass-torts/:id/:type",
    name: "MassTortMatter",
    props: true,
    component: MassTortMatter
  },
  // {
  //   path: "/admin/mass-torts/:id/:type/contents",
  //   name: "AdminContentsStepper",
  //   props: true,
  //   component: AdminContentsStepper
  // },
  {
    path: "/admin/mass-torts/:location/:type/contents",
    name: "ContentsStepper3",
    props: true,
    component: ContentsStepper3
  },
  {
    path: "/contents-list/:location",
    name: "ContentsList",
    props: true,
    component: ContentsList
  },
  {
    path: "/intake/bobcat-fire/:firm",
    name: "BobcatFire",
    props: true,
    component: BobcatFire
  },
  {
    path: "/intake/dixie-fire/",
    name: "DixieFire",
    props: true,
    component: DixieFire
  },
  {
    path: "/matters",
    name: "Matters",
    component: Matters
    // beforeEnter: AuthGuard
  },
  {
    path: "/matters/new",
    name: "CreateMatter",
    component: CreateMatter
    // beforeEnter: AuthGuard
  },
  {
    path: "/matters/:id",
    name: "Matter",
    props: true,
    component: Matter
  },

  //old version of clienForm component - no longer in use
  {
    path: "/firm/:firm/matter/:matter/client/:id",
    name: "PartyForm",
    props: true,
    component: PartyForm
  },
  {
    path: "/client/:firm/:matter/:client/:form/:id",
    name: "ClientForm",
    props: true,
    component: ClientForm
  },
  {
    path: "/matters/:id/:client/discovery",
    name: "Discovery",
    props: true,
    component: Discovery
  },
  {
    path: "/matters/:id/:client/demand",
    name: "Demand",
    props: true,
    component: Demand
  },
  {
    path: "/matters/:id/:client/discovery/propounding",
    name: "Propound",
    props: true,
    component: Propound
  }

  // {
  //   //how to route the form?
  //   path: "/:matter/form/:id/:client/:form/:id",
  //   name: "SelectedDocForm",
  //   props: true,
  //   component: SelectedDocForm
  // },

  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
